module.exports = __webpack_public_path__ + "static/media/emojis_10.9b800c84.svg";